export default "__VITE_ASSET__Mcx6bIOq__"